import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Card, createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";

import {
  scheduledataSelector,
  scheduledata_setToday,
  scheduledata_setCurrentWeekNumber,
  scheduledata_fetchData
} from "reducers/scheduledata/scheduledata";
import { fetchData, menudataSelector } from "reducers/menudata/menudata";
import {
  orderdataSelector,
  orderdata_fetchData
} from "reducers/orderdata/orderdata";
import {
  todayLocaleDateString,
  calculateCurrentWeek
} from "routes/app/routes/Schedule/ScheduleHelper";

import Navbar from "routes/app/routes/Schedule/ScheduleNavbar";
import OrderWeek from "./OrderWeek";
import { getUser } from "services/auth";
import { appdataSelector, appdata_updateServerTime } from "reducers/appdata/appdata";
const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: "#008752"
    }
  },
  backdrop: {
    zIndex: 9999999,
    color: "#000"
  }
});

function Orders(props) {
  const dispatch = useDispatch();
  const scheduleData = useSelector(scheduledataSelector);
  const menudata = useSelector(menudataSelector);
  const orderdata = useSelector(orderdataSelector);
  const appdata = useSelector(appdataSelector);

  useEffect(() => {
    // once on load
    console.log("Schedule - init");

    if (!appdata.serverTime) {
      dispatch(appdata_updateServerTime());
    }

    if ((menudata && !menudata.loaded) || menudata.needsUpdate) {
      console.log("should go get data");
      dispatch(fetchData());
    }

    if (!scheduleData.today) {
      // go get today
      // go get today
      // go get today
      let today = todayLocaleDateString();
      dispatch(scheduledata_setToday(today));
    }

    if (!scheduleData.currentWeekNumber) {
      // set number of current week
      // set number of current week
      // set number of current week
      let currentweeknumber = calculateCurrentWeek();
      dispatch(scheduledata_setCurrentWeekNumber(currentweeknumber));
    }

    // start a timer to call for the servertime every minute
    const interval = setInterval(() => {
      dispatch(appdata_updateServerTime());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // watch the scheduledata

    if (
      scheduleData.currentWeekNumber &&
      !Object.keys(scheduleData.menus).includes(
        String(scheduleData.selectedWeekNumber)
      ) &&
      !scheduleData.errorMessage
    ) {
      console.log("schedule should go fetch current week");
      dispatch(scheduledata_fetchData(scheduleData.selectedWeekNumber));
    } else {
      console.log("schedule, current week number already present in store");
    }

    if (!getUser()["isExternal"]) {
      if (
        !orderdata.orders.hasOwnProperty(scheduleData.selectedWeekNumber) &&
        !orderdata.loading
      ) {
        dispatch(orderdata_fetchData(false, scheduleData.selectedWeekNumber));
      }
    }

    // if the user is external, we need to fetch the grouporders, because
    // external user orders are saved as group orders

    if (getUser()["isExternal"]) {
      console.log("Orders - is external");

      if (
        !orderdata.ordersForExternal.hasOwnProperty(
          scheduleData.selectedWeekNumber
        ) &&
        !orderdata.loading
      ) {
        console.log("Orders - go get group orders");
        dispatch(
          orderdata_fetchData(true, scheduleData.selectedWeekNumber, true)
        );
      }
    }
  }, [scheduleData]);

  return (
    <Grid
      className="mt-2"
      container
      spacing={2}
      alignItems="top"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} md={10}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={defaultMaterialTheme}>
            <Card>
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <Grid container justify="space-between">
                    <Grid item xs={12} sm={6}>
                      <h2 className="article-title">My Orders</h2>
                    </Grid>
                    <Grid item xs={12} sm={6} className="text-sm-right">
                      <h2 className="article-title">
                        Today: {scheduleData.today}
                      </h2>
                    </Grid>
                    Place or update your orders.
                  </Grid>
                  <div className="mt-4 mb-4">
                    <Navbar></Navbar>
                  </div>
                </div>
              </article>
            </Card>
            <div className="mt-2">
              <OrderWeek></OrderWeek>
            </div>
            <Card className="mt-4 d-none">
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <div>
                    <h2 className="article-title mb-4">Todo's</h2>
                    <ul>
                      <li>
                        <s>
                          Make sure orders can not be placed after time has
                          expired
                        </s>
                      </li>
                      (right now opening the menu before 11 and keeping it open
                      allows for orders placed after time )
                      <li>
                        <s>disable ordering for past days</s>
                      </li>
                      <li>
                        <s>
                          make ordering on current day only possible untill ...
                        </s>
                      </li>
                      <li>
                        <s>display allergies</s>
                      </li>
                      <li>
                        <s>enable cancel feature</s>
                      </li>
                      <li>
                        <s>make menus selectable</s>
                      </li>
                      <li>
                        <s>add save button / save on change?</s>
                      </li>
                      <li>
                        <s>save selection to SAP</s>
                      </li>
                    </ul>
                  </div>
                </div>
              </article>
            </Card>
          </ThemeProvider>
        </StyledEngineProvider>
      </Grid>
    </Grid>
  );
}

export default Orders;
